import React from "react";
import styled from "styled-components";
import { Colors } from "../../theme/types";
import Text from "./Text";
import { TextProps } from "./types";

const TooltipText = styled(Text)<{ decorationColor?: keyof Colors }>`
  text-decoration: underline dotted;
  text-decoration-color: ${({ theme, decorationColor }) =>
    `${theme?.colors && decorationColor ? theme.colors[decorationColor] : theme?.colors?.textSubtle}`};
  text-underline-offset: 0.1em;
`;

export default TooltipText;
